export var STYLE_TYPE;
(function (STYLE_TYPE) {
    STYLE_TYPE["COMMON"] = "common";
    STYLE_TYPE["CARD"] = "card";
})(STYLE_TYPE || (STYLE_TYPE = {}));
export var SHOW_TYPE_ENUM;
(function (SHOW_TYPE_ENUM) {
    SHOW_TYPE_ENUM[SHOW_TYPE_ENUM["TWO_LIST"] = 1] = "TWO_LIST";
    SHOW_TYPE_ENUM[SHOW_TYPE_ENUM["SIGNAL_ROW"] = 2] = "SIGNAL_ROW";
    SHOW_TYPE_ENUM[SHOW_TYPE_ENUM["THREE_COLUMN"] = 3] = "THREE_COLUMN";
})(SHOW_TYPE_ENUM || (SHOW_TYPE_ENUM = {}));
export var LOAD_MORE_TYPE;
(function (LOAD_MORE_TYPE) {
    LOAD_MORE_TYPE[LOAD_MORE_TYPE["BUTTON"] = 1] = "BUTTON";
    LOAD_MORE_TYPE[LOAD_MORE_TYPE["PULL_UP"] = 2] = "PULL_UP";
})(LOAD_MORE_TYPE || (LOAD_MORE_TYPE = {}));
